import React from 'react';
import { GiftIcon, SparklesIcon, ShieldPlusIcon, SproutIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-gradient-to-b from-white to-emerald-50 py-16 md:py-24" data-id="element-55">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center mb-12" data-id="element-57">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-58">
            <GiftIcon className="w-10 h-10 text-emerald-700" data-id="element-59" />
            <SparklesIcon className="w-8 h-8 text-emerald-700" data-id="element-60" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-61">
            Your Free Bonus Guides
          </h2>
          <p className="text-xl text-stone-700" data-id="element-62">
            These bonus guides are included FREE with your purchase
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-63">
          {/* Bonus #1 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-64">
            <div className="bg-emerald-700 p-6 flex items-center gap-4" data-id="element-65">
              <ShieldPlusIcon className="w-10 h-10 text-emerald-100 flex-shrink-0" data-id="element-66" />
              <div data-id="element-67">
                <p className="text-emerald-100 text-sm font-semibold uppercase tracking-wide" data-id="element-68">
                  Bonus #1
                </p>
                <h3 className="text-xl font-bold text-white" data-id="element-69">
                  Herbal First Aid — Your Natural Emergency Toolkit
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-70">
              <div className="flex items-center justify-between mb-4" data-id="element-71">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold" data-id="element-72">
                  Value: $17
                </span>
              </div>
              <p className="text-stone-700 mb-4" data-id="element-73">
                Learn how to use herbs when everyday emergencies happen.
              </p>
              <ul className="space-y-2 text-stone-600" data-id="element-74">
                <li className="flex items-start gap-2" data-id="element-75">
                  <span className="text-emerald-700 font-bold" data-id="element-76">✓</span>
                  <span data-id="element-77">
                    Natural protocols for burns, cuts, infections, and bug bites
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-78">
                  <span className="text-emerald-700 font-bold" data-id="element-79">✓</span>
                  <span data-id="element-80">
                    Step-by-step remedies for headaches, inflammation, and
                    digestive upset
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-81">
                  <span className="text-emerald-700 font-bold" data-id="element-82">✓</span>
                  <span data-id="element-83">
                    Simple herbal formulas using ingredients already found in
                    your kitchen
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-84">
                  <span className="text-emerald-700 font-bold" data-id="element-85">✓</span>
                  <span data-id="element-86">
                    A practical home reference for natural emergency
                    preparedness
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bonus #2 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-87">
            <div className="bg-emerald-700 p-6 flex items-center gap-4" data-id="element-88">
              <SproutIcon className="w-10 h-10 text-emerald-100 flex-shrink-0" data-id="element-89" />
              <div data-id="element-90">
                <p className="text-emerald-100 text-sm font-semibold uppercase tracking-wide" data-id="element-91">
                  Bonus #2
                </p>
                <h3 className="text-xl font-bold text-white" data-id="element-92">
                  The Backyard Herbal Medicine Garden
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-93">
              <div className="flex items-center justify-between mb-4" data-id="element-94">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold" data-id="element-95">
                  Value: $17
                </span>
              </div>
              <p className="text-stone-700 mb-4" data-id="element-96">
                Learn how to grow the exact herbs used in your remedies — even
                if you've never gardened before.
              </p>
              <ul className="space-y-2 text-stone-600" data-id="element-97">
                <li className="flex items-start gap-2" data-id="element-98">
                  <span className="text-emerald-700 font-bold" data-id="element-99">✓</span>
                  <span data-id="element-100">
                    Step-by-step guide to growing 12 essential medicinal herbs
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-101">
                  <span className="text-emerald-700 font-bold" data-id="element-102">✓</span>
                  <span data-id="element-103">Works for backyards, balconies, or indoor spaces</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-104">
                  <span className="text-emerald-700 font-bold" data-id="element-105">✓</span>
                  <span data-id="element-106">
                    Learn proper harvesting and storage for maximum potency
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-107">
                  <span className="text-emerald-700 font-bold" data-id="element-108">✓</span>
                  <span data-id="element-109">Build your own living herbal medicine cabinet</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="bg-emerald-700 text-white rounded-xl p-8 text-center" data-id="element-110">
          <p className="text-3xl font-bold mb-2" data-id="element-111">
            Total Bonus Value:{' '}
            <span className="relative inline-block px-1" data-id="element-112">
              <span className="relative z-10" data-id="element-113">$34</span>
              <span className="absolute left-0 right-0 top-1/2 -translate-y-1/2" style={{
              transform: 'translateY(-50%) rotate(-20deg)',
              transformOrigin: 'center'
            }} data-id="element-114">
                <span className="block w-full h-0.5 bg-white" data-id="element-115"></span>
              </span>
            </span>
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-116">
            <SparklesIcon className="w-6 h-6 text-emerald-200" data-id="element-117" />
            <p className="text-2xl" data-id="element-118">
              Yours <span className="font-bold" data-id="element-119">FREE</span> Today With Your
              Purchase
            </p>
            <SparklesIcon className="w-6 h-6 text-emerald-200" data-id="element-120" />
          </div>
        </div>
      </div>
    </section>;
}